import {
    attemptToCreateFormEntry,
    clearInteractionError,
    forumEntriesReceivedCount,
    forumNewestEntriesBatch,
    forumTopEntriesBatch,
    getCurrentForumPage,
    getForum,
    getForumSortMode,
    getInteractionError,
    getLastUpdateSource,
    getShowChannel,
    isForumLive,
    retrieveForum,
    retrieveForumPage,
    setForumLive,
    sortForumAndRefresh,
    upVoteForumEntry,
} from 'redux/slices/interaction'
import { bindActionCreators, compose } from 'redux'

import Button from 'react-bootstrap/Button'
import Constants from 'constants.js'
import Container from 'react-bootstrap/Container'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Form from 'react-bootstrap/Form'
import ForumPost from 'components/set/ForumPost/ForumPost'
import ForumTabs from 'components/set/ForumTabs/ForumTabs'
import InputGroup from 'react-bootstrap/InputGroup'
import Overlay from 'react-bootstrap/Overlay'
import Popover from 'react-bootstrap/Popover'
import React from 'react'
import _ from 'lodash'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { getShow } from 'redux/slices/liveShow'
import { openModal, ModalContent } from 'redux/slices/globalModal'
import styles from './styles'
import { withStyles } from '@material-ui/styles'

class Forum extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            target: null,
            scrolledToTop: true,
        }
        this.popoverRef = target => this.setState({ target })

        this.entryScrollRef = React.createRef()
    }

    componentDidMount() {
        const { wsChannel } = this.props
        if (wsChannel) {
            wsChannel.bind(Constants.WEBSOCKET_FORUM_NEWEST_ENTRIES_BATCH, this.props.forumNewestEntriesBatch)
            wsChannel.bind(Constants.WEBSOCKET_FORUM_TOP_ENTRIES_BATCH, this.props.forumTopEntriesBatch)
        }
    }

    componentWillUnmount() {
        const { wsChannel } = this.props
        if (wsChannel) {
            wsChannel.unbind(Constants.WEBSOCKET_FORUM_NEWEST_ENTRIES_BATCH, this.props.forumNewestEntriesBatch)
            wsChannel.unbind(Constants.WEBSOCKET_FORUM_TOP_ENTRIES_BATCH, this.props.forumTopEntriesBatch)
        }
    }

    getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.forumEntries.length === 0) return null

        // Not all updates should result in forcing the scrollbar's position
        const userNewEntry = this.props.forumLastUpdateSource === 'new-entry-authored'

        if (!this.props.isForumLive && this.props.forumEntriesReceivedCount > 0 && userNewEntry)
            return { moveScroll: true }

        return null
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot !== null && snapshot.moveScroll) this.scrollToTop()
    }

    scrollToTop = () => {
        this.entryScrollRef.current.scrollTop = 2
        this.setState({ scrolledToTop: true })
    }

    onSubmitEntryHandler = async e => {
        e.preventDefault()

        // Show the login modal if the user is not logged in
        if (!this.props.isAuthenticated) {
            this.props.openModal({ content: ModalContent.SIGNUP })
            return
        }

        let forumEntryVal = _.get(this, 'forumEntryVal.value')
        let body = {
            showId: _.get(this, 'props.show._id'),
            body: forumEntryVal,
        }

        this.forumEntryVal.value = '' //Clear the input
        await this.props.attemptToCreateFormEntry(body, this.props.user)

        if (this.props.forumEntries.length < Constants.FORUM.FORUM_MAX_ENTRIES_IN_MEMORY) {
            const entryScroll = this.entryScrollRef.current
            let scrollTo

            switch (this.props.forumSortMode) {
                case Constants.FORUM.FORUM_SORT_TOP:
                    scrollTo = entryScroll.scrollHeight
                    break
                case Constants.FORUM.FORUM_SORT_NEW:
                    scrollTo = 0
                    break
                default:
                    scrollTo = entryScroll.scrollTop
                    break
            }
            entryScroll.scrollTop = scrollTo
        }
    }

    upVoteHandler = entry => {
        // Show the login modal if the user is not logged in
        if (!this.props.isAuthenticated) {
            this.props.openModal({ content: ModalContent.SIGNUP })
            return
        }

        // Don't upvote if user already upvoted this entry
        if (entry.upvoteUsers.includes(this.props.user._id)) return

        this.props.upVoteForumEntry({ entryId: entry._id, userId: this.props.user._id })
    }

    refreshForum = () => {
        this.props.retrieveForum(this.props.show._id, {
            count: Constants.FORUM.FORUM_MAX_ENTRIES_IN_MEMORY,
            sort: this.props.forumSortMode,
        })
    }

    handleScroll = _.debounce(() => {
        if (!this.entryScrollRef.current) return

        const el = this.entryScrollRef.current
        const scrolledToBottom = el.scrollHeight - el.scrollTop === el.clientHeight
        const scrolledToTop = el.scrollTop < 10

        this.setState({ scrolledToTop })
        this.props.setForumLive(scrolledToTop)

        if (scrolledToBottom && this.props.forumEntries.length >= Constants.FORUM.FORUM_MAX_ENTRIES_IN_MEMORY) {
            this.props.retrieveForumPage(this.props.show._id)
        } else if (scrolledToTop && !this.props.isForumLive) this.refreshForum()
    }, 200)

    handleSortChange = eventKey => {
        this.props.sortForumAndRefresh(this.props.show._id, eventKey)
    }

    renderForumEntries = () => {
        if (this.props.forumEntries.length === 0)
            return <p className={this.props.classes.emptyText}> Artists will see your comments and questions here. </p>

        return this.props.forumEntries.map(entry => (
            <ForumPost
                entry={entry}
                upvoteHandler={this.upVoteHandler}
                userId={_.get(this.props, 'user._id')}
                key={entry._id}
            />
        ))
    }

    render() {
        const { classes, fullScreen = false } = this.props

        return (
            <Container
                className={clsx(classes.forum, {
                    [classes.fullScreen]: fullScreen,
                })}
            >
                {!fullScreen && <ForumTabs onTabChange={this.handleSortChange} className={classes.forumTabs} />}

                {!this.state.scrolledToTop && (
                    <button className={clsx(classes.refreshQuestions, 'btn btn-secondary')} onClick={this.scrollToTop}>
                        refresh questions
                    </button>
                )}
                <div className={classes.forumEntries} onScroll={this.handleScroll} ref={this.entryScrollRef}>
                    {this.renderForumEntries()}
                </div>
                <Container
                    className={clsx(classes.forumInput, 'bg-dark-1', {
                        [classes.removePadding]: fullScreen,
                    })}
                    ref={this.popoverRef}
                >
                    <Form
                        className={clsx('bg-dark-1', classes.dark)}
                        onSubmit={e => this.onSubmitEntryHandler(e)}
                        id="ata-form"
                    >
                        <Form.Group>
                            <InputGroup className={classes.inputGroup}>
                                <input
                                    placeholder="Be thoughtful, you only get 5 posts"
                                    maxLength="200"
                                    className={classes.dark}
                                    ref={node => (this.forumEntryVal = node)}
                                />
                                {!this.props.fullScreen && (
                                    <InputGroup.Append>
                                        <Button
                                            variant="secondary"
                                            className={classes.submitBtn}
                                            type="submit"
                                            id="ata-submit-btn"
                                        >
                                            <FontAwesomeIcon icon={faPaperPlane} color="#D3D5DB" />
                                        </Button>
                                    </InputGroup.Append>
                                )}
                            </InputGroup>
                        </Form.Group>
                    </Form>
                </Container>

                <Overlay
                    target={this.state.target}
                    show={!!this.props.forumPopoverErrorMessage}
                    placement="top"
                    rootClose
                    onHide={() => this.props.clearInteractionError()}
                >
                    <Popover>
                        <Container>
                            <div className="body-2">{this.props.forumPopoverErrorMessage}</div>
                        </Container>
                    </Popover>
                </Overlay>
            </Container>
        )
    }
}

const mapStateToProps = state => ({
    show: getShow(state),
    wsChannel: getShowChannel(state),
    forumEntries: getForum(state),
    forumSortMode: getForumSortMode(state),
    isForumLive: isForumLive(state),
    forumEntriesReceivedCount: forumEntriesReceivedCount(state),
    forumPagesRequested: getCurrentForumPage(state),
    forumLastUpdateSource: getLastUpdateSource(state),
    forumPopoverErrorMessage: getInteractionError(state),
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            attemptToCreateFormEntry,
            upVoteForumEntry,
            sortForumAndRefresh,
            retrieveForum,
            retrieveForumPage,
            forumNewestEntriesBatch,
            clearInteractionError,
            forumTopEntriesBatch,
            setForumLive,
            openModal,
        },
        dispatch,
    )

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Forum)
